"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  // main
  black: '#222',
  gray7: '#777',
  gray9: '#999',
  grayB: '#b3b3b3',
  grayD: '#d1d1d1',
  grayE: '#eaeaea',
  grayF: '#f6f6f6',
  white: '#fff',
  red: '#DC1A1A',
  // blandColor
  blue: '#4abfe6',
  // green: '#60df52',
  // #0E8A01 テキストリンクの色 interactive-text-02
  green: '#0E8A01',
  stayPink: '#dc4d6f',
  // rental
  blueBdColor: '#42a9cc',
  subBgColor: '#e8f6fb',
  // stay
  stayPinkBdColor: '#b82346',
  stayLightPink: '#ee597c',
  // work
  workBlue: '#126DF3',
  // rental & dashboard & business
  // メイン導線となるボタン色 interactive-button-02
  greenButtonColor: '#20BE0E',
  // 選択中の要素の文字など interactive-active-02
  greenSelectedButtonColor: '#0E8A01',
  // 選択中の要素の背景など interactive-light-02
  lightgreenSelectedColor: '#EAF8E9',
  greenBdColor: '#60ce52',
  lightgreen: '#eaf8e9',
  lightgreenBdColor: '#e4f2e3',
  primaryColors: {
    stay: '#dc4d6f',
    www: '#4abfe6'
  },
  secondaryColors: {
    stay: '#21a8b4',
    www: '#60df52'
  },
  borderColors: {
    stay: '#b82346',
    www: '#42a9cc'
  },
  primaryLightColors: {
    stay: '#ee597c',
    www: '#76cce8'
  },
  borderLightColors: {
    stay: '#b82346',
    www: '#89c7dc'
  },
  // iconColor
  yellow: '#f2d42b',
  // SNS
  twitter: '#1da1f2',
  facebook: '#305197'
};
exports["default"] = _default;